module.exports = __webpack_public_path__ + "static/contenu-2f9be5ac75e70fb8ef7f08fcaecf85af.jpg";